import { onError } from '@apollo/client/link/error';
import { showMessage } from 'src/common/state/message.state';
import { i18n } from 'src/common/utils/translate.util';

/**
 * Error codes the API returns when a request was refused for rate reasons.
 * Deliberately NOT `CAPTCHA_REQUIRED`: a challenge is not an error to toast — the
 * submitting form owns it (renders the widget and retries), see
 * `hooks/useCreateSoWithCaptcha.hook.tsx` and `captcha.ts`.
 */
const RATE_LIMIT_CODES = ['RATE_LIMITED', 'IP_BLOCKED'];

/**
 * Surfaces rate-limit denials to the user with the neutral copy.
 *
 * The toast is the one place a denial is explained to the customer; the mutation
 * itself still rejects (`errorPolicy: 'none'` in client.tsx), so the call site's
 * catch runs and nothing advances. `showMessage` is a plain reactive-var setter (no
 * store), so it can be called from the link directly.
 */
export const rateLimitErrorLink = onError(({ graphQLErrors }) => {
  if (!graphQLErrors?.length) return;
  const denial = graphQLErrors.find((error) =>
    RATE_LIMIT_CODES.includes(String(error.extensions?.code)),
  );
  if (denial) {
    showMessage({ type: 'error', message: i18n.t('common.rateLimited'), duration: 8000, fixed: true });
  }
});
